import { Outlet } from 'react-router-dom'

const Companies = () => {
  return <Outlet />
}

export default Companies
